import { render, staticRenderFns } from "./about.vue?vue&type=template&id=70da6fc5&scoped=true&"
import script from "./about.vue?vue&type=script&lang=ts&"
export * from "./about.vue?vue&type=script&lang=ts&"
import style0 from "./about.vue?vue&type=style&index=0&id=70da6fc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70da6fc5",
  null
  
)

export default component.exports